'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _css = require('antd/lib/date-picker/style/css');

var _datePicker = require('antd/lib/date-picker');

var _datePicker2 = _interopRequireDefault(_datePicker);

var _css2 = require('antd/lib/input/style/css');

var _input = require('antd/lib/input');

var _input2 = _interopRequireDefault(_input);

var _css3 = require('antd/lib/radio/style/css');

var _radio = require('antd/lib/radio');

var _radio2 = _interopRequireDefault(_radio);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RadioButton = _radio2.default.Button;
var RadioGroup = _radio2.default.Group;
var Search = _input2.default.Search;
var RangePicker = _datePicker2.default.RangePicker;


var OrderFilter = _react2.default.createClass({
    displayName: 'OrderFilter',

    propTypes: {
        status: _react.PropTypes.arrayOf(_react.PropTypes.string.isRequired).isRequired,
        filter: _react.PropTypes.object.isRequired,
        onChange: _react.PropTypes.func.isRequired
    },
    onStatusChange: function onStatusChange(e) {
        this.props.onChange('status', e.target.value);
    },
    onDateChange: function onDateChange(date, dateString) {
        this.props.onChange('date', dateString);
    },
    onKeywordChange: function onKeywordChange(keyword) {
        this.props.onChange('keyword', keyword);
    },
    render: function render() {
        var _props$filter = this.props.filter,
            status = _props$filter.status,
            date = _props$filter.date,
            keyword = _props$filter.keyword;

        return _react2.default.createElement(
            'div',
            { className: 'filter' },
            _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'span',
                    null,
                    '\u8BA2\u5355\u72B6\u6001\uFF1A'
                ),
                _react2.default.createElement(
                    RadioGroup,
                    { onChange: this.onStatusChange, value: status },
                    _react2.default.createElement(
                        RadioButton,
                        { value: -1 },
                        '\u5168\u90E8'
                    ),
                    this.props.status.map(function (status, id) {
                        return _react2.default.createElement(
                            RadioButton,
                            { key: id, value: id },
                            status
                        );
                    })
                )
            ),
            _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'span',
                    null,
                    '\u521B\u5EFA\u65F6\u95F4\uFF1A'
                ),
                _react2.default.createElement(RangePicker, { onChange: this.onDateChange, defaultValue: date.length > 0 ? [(0, _moment2.default)(date[0]), (0, _moment2.default)(date[1])] : null })
            ),
            _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'span',
                    null,
                    '\u5173\u952E\u8BCD\uFF1A\xA0\xA0\xA0\xA0'
                ),
                _react2.default.createElement(Search, {
                    placeholder: '\u8BA2\u5355\u53F7\uFF0F\u5546\u54C1\u540D\uFF0F\u6536\u8D27\u4EBA\u59D3\u540D\uFF0F\u6536\u8D27\u4EBA\u624B\u673A\u7B49\uFF0C\u6309\u56DE\u8F66\u952E\u641C\u7D22',
                    onSearch: this.onKeywordChange,
                    defaultValue: keyword
                })
            )
        );
    }
});

exports.default = OrderFilter;


//////////////////
// WEBPACK FOOTER
// ./src/js/components/order_filter.js
// module id = 1121
// module chunks = 0